import React, { useContext } from 'react';
import * as S from './styled';
import { useSnackbar } from 'notistack';
import Form from '../..';
import {
  defaultBlurTaxForm,
  defaultTaxForm,
} from '../../../../store/invoice/utils';
import { ExportContext } from '../../../../provider/ExportProvider';
import { formatBRL, formatCents } from '../../../../store/masks';

export default function FormTaxCreate() {
  const {
    getInvoice,
    setInvoice,
    createTax,
    setModal,
    getFormMessage,
    validateForm,
  } = useContext(ExportContext)!.controllers.tax;
  const { enqueueSnackbar } = useSnackbar();

  const getForm = <T extends keyof TaxForm>(field: T) =>
    getInvoice(`forms.taxes.create.${field}`);

  const setForm = <
    T extends keyof TaxForm,
    V extends DeepType<InvoiceState, `forms.taxes.create.${T}`>,
  >(
    field: T,
    value: V,
  ) => setInvoice(`forms.taxes.create.${field}`, value);

  const blurField = (field: keyof TaxForm) => () => {
    setInvoice(`blur.taxes.create.${field}`, true);
  };

  const clearForm = () => {
    setInvoice(`forms.taxes.create`, defaultTaxForm());
    setInvoice(`blur.taxes.create`, defaultBlurTaxForm());
  };

  const messages = getFormMessage('taxes.create');

  const [loading, setLoading] = React.useState(false);
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    validateForm('taxes.create')
      .then(() => {
        setLoading(true);
        createTax()
          .then((tax) => {
            enqueueSnackbar('Taxa criada com sucesso', {
              variant: 'success',
            });
            clearForm();
            setModal('single.createTax', false);
            setInvoice('filters.taxes.data.data', [
              ...getInvoice('filters.taxes.data.data'),
              tax,
            ]);
          })
          .catch(() => {
            enqueueSnackbar('Houve uma falha ao criar a taxa', {
              variant: 'error',
            });
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {
        enqueueSnackbar('Verifique a validade dos campos', {
          variant: 'error',
        });
      });
  };

  return (
    <S.Form
      style={{
        maxHeight: '80vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <S.Grid>
          <Form.Input
            label="Nome"
            value={getForm('name')}
            onChange={(e) => setForm('name', e.target.value)}
            error={messages.name}
            onBlur={blurField('name')}
          />
          <Form.Input
            label="Descrição"
            value={getForm('description')}
            onChange={(e) => setForm('description', e.target.value)}
          />
          <Form.Input
            label="Valor"
            value={getForm('value')}
            onChange={(e) => setForm('value', +e.target.value)}
            error={messages.value}
            onBlur={blurField('value')}
            mask={formatBRL}
            unmask={formatCents}
          />
        </S.Grid>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={clearForm}>
          Limpar
        </Form.Button>
        <Form.Button loading={loading}>Criar</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
